import { useCallback, useRef } from 'react'

// Idempotency key for ONE logical money operation (a single Pay / Refund /
// Reverse / Post). The key is generated lazily on the first submit and REUSED on
// every retry, so a network-drop retry dedupes server-side (see migration 247's
// idempotency_keys table) instead of double-posting. `reset()` is called once the
// operation succeeds (or the flow is abandoned) so the next operation gets a
// fresh key. A ref — not useState — is used deliberately: the value must be
// readable synchronously inside the submit handler and must not trigger a
// re-render, which matters for guarding against a rapid double-click.
export function useIdempotencyKey() {
  const ref = useRef<string | null>(null)
  const get = useCallback(() => {
    if (!ref.current) ref.current = crypto.randomUUID()
    return ref.current
  }, [])
  const reset = useCallback(() => {
    ref.current = null
  }, [])
  return { get, reset }
}
